import { GenericAppError } from '@side/pantry';
import { useBrokerIsExternal } from '@/common/hooks/useBrokerIsExternal';
import type { SideComponentProps } from '@/common/types/app';
import { PageTitle } from '@/components/PageTitle/PageTitle';
import { PartnerMap } from '@/views/Community/views/PartnerMap';

const PartnerMapPage: SideComponentProps = () => {
  const { isExternal, isLoading } = useBrokerIsExternal();

  if (isLoading) {
    return null;
  }

  if (isExternal) {
    return <GenericAppError buttonHref="/txm" />;
  }

  return (
    <>
      <PageTitle title="Partner Map | Side" />
      <PartnerMap />
    </>
  );
};

PartnerMapPage.appShellProps = {
  hideInteractionSidebar: true,
};

PartnerMapPage.disableInteractionValidation = true;

export default PartnerMapPage;
